/*
 * 
 * Calendar.js
 * 
 * To install 
 * - npm install clndr moment lodash
 */

import 'clndr';
import 'lodash';
import * as moment from 'moment';

var $ = jQuery.noConflict();


/**
 * 
 * Monthly calendar with daily events sidebar
 *
 * @export
 * @class Calendar
 */
export default class Calendar {
  /**
   * Creates an instance of Calendar.
   * @param {sting} locale 	ISO 639-1:two-letter code 
   * @param {Object} i18n 	object with translations
   * @memberof Calendar
   */
  constructor() {
    this.startOfYear = new Date(new Date().getFullYear(), 0, 1);
    this.i18n = {
      el: {
        noEventsThisDay: 'Δεν υπάρχουν εκδηλώσεις αυτή τη μέρα',
        noEventsThisMonth: 'Δεν υπάρχουν εκδηλώσεις αυτό τo μηνα',
      }
    };
    this.locale = 'el'; 
    this.options = {
      moment: moment,
      template: $('#template-calendar-monthly').html(),
      multiDayEvents: {
        endDate: 'endDate',
        startDate: 'startDate'
      },
      forceSixRows: true,
      showAdjacentMonths: true,
      adjacentDaysChangeMonth: false,
      extras: {
        currentDate: moment().format('YYYY-MM-DD'),
        loadEventList: this.loadEventList,
        getEvents: this.getEvents,
        initMonth: this.initMonth,
        i18n: this.i18n,
        locale: this.locale
      },
      clickEvents: {
        click: function (target) {
          if (!($(target.element).hasClass('empty') || $(target.element).hasClass('adjacent-month') || $(target.element).hasClass('inactive'))) {
            const wrapper = $(this.element).closest('.monthly-clndr-wrapper')
            this.options.extras.loadEventList(target, wrapper);
            wrapper.find('.monthly-clndr .selected').removeClass('selected');
            $(target.element).addClass('selected');
          }
        },
      },
      ready: async function () {
        await this.options.extras.initMonth(this)

        const wrapper = $(this.element).closest('.monthly-clndr-wrapper')
        const titleEl = wrapper.find('.clndr-title');
        const monthEl = wrapper.find('.clndr-title .month').text(this.month.format('MMMM'));
        const yearEl = wrapper.find('.clndr-title .year').text(this.month.format('YYYY'));

        // Select current date
        wrapper.find('.monthly-clndr .calendar-day-' + this.options.extras.currentDate).click();

        wrapper.find('.clndr-controls .clndr-previous-button').click(async () => {
          this.back()
          await this.options.extras.initMonth(this, wrapper, titleEl, yearEl, monthEl)
        });
        wrapper.find('.clndr-controls .clndr-next-button').click(async () => {
          this.forward()
          await this.options.extras.initMonth(this, wrapper, titleEl, yearEl, monthEl)
        });
      }
    }

    moment.locale(this.locale);
  }

  /**
   * Get all the events for a date with categories. 
   * You can get monthly by providing YYYY-MM or yearly by providing YYYY as date format.
   *
   * @param {string} date 	The date in format YYYY-MM-DD. 
   * @returns {object}
   * @memberof Calendar
   */
  async getEvents(date) {
    const response = await fetch('/wp-json/sw/events?startDate=' + date, {
      headers: {
        'X-WP-Nonce': sw.nonce
      }
    });
    const data = await response.json();
    // const data = {
    //   "events": [
    //     {
    //       "title": "Multiday Event past & future",
    //       "startDate": "2020-10-30 00:00:00",
    //       "endDate": "2020-12-08 00:00:00",
    //       "permalink": "single-event.html"
    //     },
    //     {
    //       "title": "Even with only start date past",
    //       "startDate": "2020-10-19 00:00:00",
    //       "endDate": "",
    //       "permalink": "single-event.html"
    //     },
    //     {
    //       "title": "Νεο event",
    //       "startDate": "2020-11-20 00:00:00",
    //       "endDate": "2020-11-20 13:00:00",
    //       "permalink": "single-event.html"
    //     },
    //     {
    //       "title": "Αλλο event",
    //       "startDate": "2020-11-15 17:00:00",
    //       "endDate": "2020-11-15 18:00:00",
    //       "permalink": "single-event.html"
    //     }
    //   ]
    // };

    //Sort events by start date
    if (data.events.length > 1) {
      data.events.sort(function (a, b) {
        return Date.parse(a.startDate) < Date.parse(b.startDate) ? -1 : 1;
      });
    }
    return data;
  }

  async initMonth(clndr, wrapper, titleEl, yearEl, monthEl) {
    const data = await clndr.options.extras.getEvents(clndr.month.format('YYYY-MM-'));
    //Add events to calendar
    clndr.setEvents(data.events);

    // Reset extras and add an array with the calendars classes and names
    let extras = clndr.options.extras ? clndr.options.extras : {};
    $(clndr.calendarContainer.selector).addClass('events-loaded');
    clndr.setExtras(extras);
    if (wrapper) {
      // Select first date of the month
      wrapper.find('.monthly-clndr .calendar-day-' + clndr.month.format('YYYY-MM-DD')).click();
    }

    if (titleEl) {
      titleEl.animate({
        opacity: 0,
      }, 400, function () {
        if (monthEl) {
          monthEl.text(clndr.month.format('MMMM'));
        }
        if (yearEl) {
          yearEl.text(clndr.month.format('YYYY'));
        }
        titleEl.animate({
          opacity: 1,
        });
      });
    }
  }

  /**
   * Creates the event list for montly calendar
   *
   * @param {Object} target 		object containing the DOM element, any events, and the date as a moment.js object
   * @param {JQuery} parentEl 	Calendar wrapper
   * @memberof Calendar
   */
  async loadEventList(target, parentEl) {
    let eventListTemplate = '<h3 class="date-events mb-70"><time datetime="' + target.date.format('YYYY-MM-DD') + '">' + target.date.format('dddd D MMMM YYYY') + '</h3>';
    if (target.events.length) {
      if(target.events.length == 1){
        eventListTemplate += '<p class="timeline-label">' + target.events.length + ' Πολιτιστικό Δρώμενο</p>';
      }else{
        eventListTemplate += '<p class="timeline-label">' + target.events.length + ' Πολιτιστικά Δρώμενα</p>';
      }
      eventListTemplate += '<ul class="timeline">';
      await target.events.map(async (event) => {
        let eventTemplate = '<li class="event timeline-event"><a class="event-link" href="' + (event.permalink ? event.permalink : '#event') + '"><div class="content">';
        eventTemplate += '<p class="timeline-event-date">' + moment(event.startDate).format('HH:mm') + '</p>';
        eventTemplate += '<h4 class="timeline-event-title">' + event.title + '</h4>';

        eventListTemplate += eventTemplate + '</div></a></li>';
        parentEl.find('.events-list').html(eventListTemplate)
      });
      eventListTemplate += '</ul>'
    } else {
      eventListTemplate += '<p>' + this.i18n[this.locale].noEventsThisDay + '</p>'
      parentEl.find('.events-list').html(eventListTemplate);
    }

  }

}
